import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-item-texto',
  templateUrl: './item-texto.component.html',
  styleUrls: ['./item-texto.component.scss']
})
export class ItemTextoComponent {
 @Input() titulo: string;
 @Input() conteudo: string;
 @Input() tituloBold: boolean = false;
 @Input() textoSucesso: boolean = false;
}
